import { render, staticRenderFns } from "./CorporationSettingHoliday.vue?vue&type=template&id=1959d9b5&"
import script from "./CorporationSettingHoliday.vue?vue&type=script&lang=js&"
export * from "./CorporationSettingHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports